import { Button } from 'components/ui/ButtonGs';
import * as React from 'react';

type Props = React.ComponentProps<'button'> & {
  visible: boolean
};

export const ClearFiltersButton = ({ visible, ...props }: Props) => {
  if (!visible) return null;

  return (
    <Button.Root {...props} size={'xs'} variant={'ghost'} className={'ml-auto'}>
      Limpar filtros
    </Button.Root>
  );
};